import { render, staticRenderFns } from "./AreaModal.vue?vue&type=template&id=9ebcd5a6&"
import script from "./AreaModal.vue?vue&type=script&lang=js&"
export * from "./AreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ebcd5a6')) {
      api.createRecord('9ebcd5a6', component.options)
    } else {
      api.reload('9ebcd5a6', component.options)
    }
    module.hot.accept("./AreaModal.vue?vue&type=template&id=9ebcd5a6&", function () {
      api.rerender('9ebcd5a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/BaseData/Venue/modules/AreaModal.vue"
export default component.exports